module.exports = __webpack_public_path__ + "img/banner.d07993a1.png";